import { RouterProvider } from "react-router-dom"
import { ThemeProvider } from "@mui/material"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import theme from "./utils/muiTheme"
import router from "./routes/routes"
import store from "./redux/store"
import "./assets/styles/main.css"


const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <RouterProvider router={router} />
    </ThemeProvider>
  </Provider>
)